import { useState } from 'react';

export default function useAnalyticsData() {
  const [ageGroupData, setAgeGroupData] = useState([]);
  const [classificationAgeData, setClassificationAgeData] = useState([]);
  const [nationalityData, setNationalityData] = useState([]);
  const [raceData, setRaceData] = useState([]);
  const [tenureData, setTenureData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [showDepartmentModal, setShowDepartmentModal] = useState(false);
  const [averageTenure, setAverageTenure] = useState(null);

  const setters = {
    setAgeGroupData,
    setClassificationAgeData,
    setNationalityData,
    setRaceData,
    setTenureData,
    setGenderData,
    setDepartmentData,
    setAverageTenure,
  };

  return {
    ageGroupData, classificationAgeData, nationalityData,
    raceData, tenureData, genderData,
    departmentData, showDepartmentModal, setShowDepartmentModal,
    averageTenure,
    ...setters,
  };
}
